import type { Locale } from '@t4s/api-client/model'

/**
 * The four languages a tenant can enable, and the names this console shows for them.
 *
 * One table, read by the create form, the settings form and the tenant list — each of which
 * used to carry its own copy of the labels, or (in the list's case) showed the raw code.
 * A language is named in **its own language** ("Deutsch", not "German"): that is how the
 * tenant's staff will see it in their own picker, and it is how the owner will be asked
 * about it on the phone.
 */
export const LOCALES: readonly Locale[] = ['de', 'en', 'ru', 'uk']

export const LOCALE_LABELS: Readonly<Record<Locale, string>> = {
  de: 'Deutsch',
  en: 'English',
  ru: 'Русский',
  uk: 'Українська',
}
